<div [ngClass]="inWishlist ? 'w-12 center p-l-2 p-r-2' : 'right-2' ">

    <div [ngClass]="inWishlist && 'p-a-1 bg-col-w flex flex-middle flex-justify-center' ">
        <action class="wishlist-button cursor-pointer"
                [status]="status"
                (click)="toggle()"
                cy-wishlistAddBtn>
            <i class="inline-flex"
               [ngClass]="inWishlist ? 'icon-wishlist-fill col-1' : 'icon-wishlist'"
               [style.font-size.em]="1.1"
               aria-hidden="true"></i>
        </action>


        @if (inWishlist) {
        <span class="p-l-2"
              sizeClass="XL:p1"
              [ngClass]="{'p3': gridSize === 2, 'p2': gridSize === 1 }">{{'Added to wishlist' | translate}}</span>
        }
    </div>

</div>
